export enum LabelRecipe {
    Annotation,
    StudioNext
}
